import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { hasAllContractTypes as hasAllContractTypesUtil } from '../utils/voucherUtils';
import { useVoucherContractSummary } from './useVoucherContractSummary';
export function useNewBenefitHiringEligibility(contractId) {
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFlags } = useFeatureFlag();
    const isPatEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_ENABLE_PAT);
    const voucherContractId = isPatEnabled && contractId ? contractId : null;
    const { vouchers, isLoading: isLoadingVouchers } = useVoucherContractSummary({ voucherContractId });
    const allTypes = hasAllContractTypesUtil(vouchers);
    const hasAnyProduct = (vouchers?.length ?? 0) > 0;
    return {
        isPatEnabled,
        isLoading: isLoadingFlags || (isPatEnabled && isLoadingVouchers),
        hasAllContractTypes: allTypes,
        canContractNewBenefit: isPatEnabled && hasAnyProduct && !allTypes,
    };
}
